import {Component, computed, effect, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {notImplementedYet} from "../../../../app.constants";
import {RightSearchResource} from "../../../../service/RightSearchResource";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {RightDetailComponent} from "../right-detail/right-detail.component";
import {RegisterPanelComponent} from "../register-panel/register-panel.component";
import {
  RegisterMethod,
  RegistrantType,
  RightSearchResult,
  SmartCardResponse,
  Source,
  UserData
} from "../../../../../generated-model/model";
import {MenuStageService} from "../../../../shared/commons/services/menu-stage.service";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {ActivatedRoute, Router} from "@angular/router";
import {BtnLk2Component} from "../../../../shared/components/btn-lk2/btn-lk2.component";
import {RegistrationUtils} from "../../../../shared/commons/utils/registration-utils";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {StringUtils} from "../../../../shared/commons/gt-ng-datepicker/utils/string-utils";
import {UserDataService} from "../../../../security/user-data.service";
import {SmartCardComponent} from "../../../../shared/components/smart-card/smart-card.component";
import {RegisterProxyComponent} from "../../register/proxy/register-proxy.component";
import {HasAnyAuthorityDirective} from "../../../../security/has-any-authority.directive";

@Component({
  selector: 'app-right-search-by-id-card',
  standalone: true,
  imports: [
    FormsModule,
    GtNgDatepickerModule,
    NotFoundComponent,
    RightDetailComponent,
    RegisterPanelComponent,
    SharedCommonModule,
    BtnLk2Component,
    SmartCardComponent,
    RegisterProxyComponent,
    HasAnyAuthorityDirective
  ],
  templateUrl: './right-search-by-id-card.component.html',
  styleUrl: './right-search-by-id-card.component.scss'
})
export class RightSearchByIdCardComponent implements OnInit {

  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  user = signal<UserData>(undefined);
  checkRightsResource = inject(RightSearchResource);
  menuStateService = inject(MenuStageService)
  data = signal(undefined as RightSearchResult);
  protected readonly notImplementedYet = notImplementedYet;
  fromMenu = computed(() => this.menuStateService.getStoredMenu())
  private userDataService = inject(UserDataService);
  checkDate = model<string>(undefined);
  checkTime = model<string>(undefined);
  maxDate = signal<NgbDateStruct>(undefined);
  smartCardResponse: SmartCardResponse;
  agentError: boolean = false
  source = model<Source>('NHSO');
  registrantType: RegistrantType = undefined;
  registerMethod: RegisterMethod = 'IDCARD';
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  canBeRegistered = signal<boolean>(false);
  activeId = signal<number>(1);

  constructor() {
    effect(() => {
      this.canBeRegistered.set(
        this.activeId() == 1
        && this.data()
        && !this.data()?.personalFundBackDateList?.length
        && RegistrationUtils.showRegisterPanel(this.data()?.personalData, this.data()?.personalFundList?.[0])
      );
    }, {allowSignalWrites: true});
  }

  ngOnInit(): void {
    this.userDataService.getCurrent()
      .subscribe(e => {
        this.user.set(e);
      });
    let date = new Date();
    this.maxDate.set({year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()});
    this.source.set('NHSO');
    this.resetSearchParams();

    // this.smartCardResponse = {pid: "1600100501055"}
    // this.rightSearch(this.smartCardResponse?.pid);
  }

  rightSearch(personalId: string) {
    this.registrantType = undefined;
    let effectiveDate;
    if (this.checkTime()) {
      effectiveDate = `${this.checkDate()}T${this.checkTime()}`;
    } else {
      effectiveDate = `${this.checkDate()}T00:00:00`;
    }
    this.checkRightsResource.search(personalId, effectiveDate, this.source())
      .subscribe({
        next: value => {
          this.data.set(value);
        }
      });
  }

  onRead(smartCardResponse: SmartCardResponse) {
    this.smartCardResponse = smartCardResponse;
    this.rightSearch(this.smartCardResponse?.pid);
  }

  resetSearchParams() {
    this.resetCheckDateTime()
    this.source.set('NHSO');
  }

  resetCheckDateTime() {
    let now = new Date();
    this.checkDate.set(`${now.getFullYear()}-${StringUtils.paddingZeroLeft(now.getMonth() + 1, 2)}-${StringUtils.paddingZeroLeft(now.getDate(), 2)}`);
    // this.checkTime.set(`00:00:00`);
    this.checkTime.set(undefined);
  }

  onTabChange(activeId: any) {
    this.activeId.set(activeId);
  }

  afterRegister() {
    this.data.set(undefined);
    this.router.navigate(['.'], {relativeTo: this.activatedRoute});
  }

  protected register(registrantType: RegistrantType): void {
    this.checkRightsResource.registerSearch(this.smartCardResponse?.pid, undefined, undefined)
      .subscribe({
        next: value => {
          this.data.set(value);
          this.registrantType = registrantType;
        }
      });
  }
}
